module.exports = __webpack_public_path__ + "img/13.b460b7f1.jpg";